<template>
  <div>
    <RegisterProgress :step="3"/>
  <div class="topup-back">
    <div v-if="loading" class="loading" v-html="$t('view.back.loading')"></div>
    <div v-if="!loading">
      <div>
        <div class="text">
          <register-status />
        </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import RegisterStatus from '@/sim-plus/components/Register/Status'
import { mapActions, mapState } from 'vuex'
import RegisterProgress from '@/sim-plus/components/Register/Progress.vue'
import { REGISTER_STATUS_PENDING } from '@/common/const/registerSim.const'
import TopupSingleMixin from '@/common/mixins/views/TopupSingle.mixin'
import { ROUTING } from '@/sim-plus/const/routing.const'
export default {
  name: 'BackView',
  mixins: [TopupSingleMixin],
  components: {
    RegisterStatus,
    RegisterProgress
  },
  computed: {
    ...mapState({
      loading: state => state.registersim.loading,
      status: state => state.registersim.statusData?.status || state.registersim.errorData?.statusDescription
    })
  },
  methods: {
    ...mapActions([
      'getRegisterSimStatus'
    ]),
    getRegisterStatus (id) {
      this.getRegisterSimStatus(id).then(() => {
        if (!this.status || REGISTER_STATUS_PENDING.includes(this.status)) {
          setTimeout(() => {
            this.getRegisterStatus(id)
          }, 2000)
        }
      })
    }
  },
  created () {
    const verificationIdverificationId = this.$route.query.verificationId
    if (!verificationIdverificationId) {
      this.$router.push(ROUTING.register).catch(() => {})
      return
    }
    this.getRegisterStatus(verificationIdverificationId)
  }
}
</script>

<style src="../assets/scss/back.scss" lang="scss"></style>
